import React, { FC } from 'react';
import { Container } from './DotsMenu.styles';
import { IDotsMenuProps } from './dotsMenu.types';

const DotsMenu: FC<IDotsMenuProps> = ({ children, ...props }) => {
  return <Container {...props}>{children}</Container>;
};

export default DotsMenu;
